<div class="category-selection-container">
    <div class="dialog-title-section">
        <h2 class="dialog-title">{{ 'permit.create.category.title' | translate }}</h2>
        <p class="dialog-subtitle">{{ 'permit.create.category.subtitle' | translate }}</p>
    </div>

    <div class="search-container">
        <div class="search-input-wrapper">
            <i class="search-icon icon-search"></i>
            <input type="text" class="search-input" [(ngModel)]="searchQuery" (ngModelChange)="onSearchChange()" [placeholder]="'permit.create.category.search_placeholder' | translate" />
        </div>
    </div>

    <div class="categories-container">
        <div class="no-results" *ngIf="filteredCategories.length === 0 && !loading">
            <h3 class="no-results-title">{{ 'permit.create.no_results.title' | translate }}</h3>
            <p class="no-results-description">{{ 'permit.create.no_results.description' | translate }}</p>
        </div>

        <div
            *ngFor="let category of filteredCategories"
            class="category-item"
            [class.selected]="isSelected(category)"
            (click)="selectCategory(category)"
            role="option"
            [attr.aria-selected]="isSelected(category)"
        >
            <div class="category-icon">
                <i [ngClass]="category.icon || 'icon-folder'"></i>
            </div>
            <div class="category-content">
                <div class="category-header">
                    <h3 class="category-title">{{ localizedName(category.name) }}</h3>
                </div>
                <p class="category-description" *ngIf="typeCount(category)">
                    {{ 'permit.config.categories.type_count' | translate: { count: typeCount(category) } }}
                </p>
            </div>
        </div>

        <div class="skeleton-loader-container" *ngIf="loading">
            <app-skeleton-loader class="skeleton-loader" height="90px" *ngFor="let i of [1, 2, 3, 4]"></app-skeleton-loader>
        </div>
    </div>
</div>
